import { MainConfigService } from './../../../services/main-config/main-config.service';
import { Component, ElementRef, HostBinding, OnDestroy, OnInit, Renderer2, ViewChild, Input } from '@angular/core';
import { MUser } from '@argalis-apps/models';
import { Subscription, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CsrfService } from '../../../services/csrf/csrf.service';
import packageJson from '../../../../../../../package.json';

@Component({
  selector: 'ags-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  @HostBinding('class') themeFlag: string;
  @ViewChild('topbarLogo') topbarLogo: ElementRef<HTMLElement>;

  @Input() userConnected: MUser.CUser;
  @Input() signout: Observable<Object>;
  @Input() userChange: Subject<MUser.CUser>;
  @Input() themingClassName: string;

  public dialogOpened = false;
  public dialogErrorMessage: string = void 0;
  public loadingRequest: boolean = void 0;
  public logoSrc: any;
  private logoAlt = 'Logo société'; // text temporaire!
  private authServiceSubscriber: Subscription;
  public version: string;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private csrfService: CsrfService,
    private mainConfig: MainConfigService
  ) {}

  ngOnInit() {
    this.version = packageJson.version;
    this.themeFlag = `${this.themeFlag || ''} ${this.themingClassName}`;
    // this.configService.setOptions({ useTestData: true }); // TODO: à raccorder au back
    this.authServiceSubscriber = this.userChange.subscribe((_userConnected: MUser.CUser) => {
      this.userConnected = _userConnected;
    });
    this.getLogo();
  }

  ngOnDestroy() {
    this.authServiceSubscriber.unsubscribe();
  }

  getLogo(): void {
    // recuperation du logo par le service
    const logoOf = this.mainConfig.getLogoOf();
    const testUrl = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g;
    logoOf.subscribe({
      next: res => {
        testUrl.test(res.data) ? (this.logoSrc = res.data) : '';
      },
      error: err => console.error(err),
      complete: () => {
        if (this.topbarLogo.nativeElement.children.length > 0) {
          for (const child of <any>this.topbarLogo.nativeElement.children) {
            this.renderer.removeChild(this.topbarLogo.nativeElement, child);
          }
        }
        // on crée et insère le logo
        const img = this.renderer.createElement('img');
        this.renderer.setAttribute(img, 'src', this.logoSrc);
        const logoAlt = this.logoAlt || 'Logo';
        this.renderer.setAttribute(img, 'alt', logoAlt);
        this.renderer.setAttribute(img, 'title', logoAlt);
        this.renderer.setAttribute(img, 'class', 'logo-height');
        this.renderer.appendChild(this.topbarLogo.nativeElement, img);
      }
    });
  }

  openSignoutDialog() {
    this.loadingRequest = false;
    this.dialogOpened = true;
  }

  closeDialog(canSignout: boolean) {
    this.dialogErrorMessage = void 0;
    this.loadingRequest = true;
    if (!canSignout) {
      this.dialogOpened = false;
      this.loadingRequest = false;
    }
    if (canSignout) {
      if (this.userConnected) {
        this.signout.subscribe(
          () => {
            this.csrfService.removeToken();
            this.dialogOpened = false;
            this.loadingRequest = false;
            this.router.navigate(['/signin']);
          },
          () => {
            // pop-up d'erreur
            this.dialogErrorMessage = 'Une erreur est survenue lors de la déconnexion';
            this.loadingRequest = false;
          }
        );
      } else {
        this.dialogOpened = false;
        this.loadingRequest = false;
      }
    }
  }

  displayNameAndLastName() {
    const capitalizeFirstLetter = (word: string) => {
      if (typeof word !== 'string' || !word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1);
    };
    let result = '';
    if (!!this.userConnected && !!this.userConnected.userInfo && !!this.userConnected.userInfo.firstName) {
      const firstName = this.userConnected.userInfo.firstName || '';
      const name = this.userConnected.userInfo.name || '';
      result += capitalizeFirstLetter(firstName);
      if (firstName) result += ' ';
      result += name.toUpperCase();
    }
    return result;
  }
}
